import React from "react";

// What bookings is. Shown only to accounts without booking access (the dashboard's no-access
// screen for bookings and the artists' locked "calendar" popup) so they know it's available.
const BookingsInfo = () => (
  <div className="max-w-[34rem] text-left">
    <div className="text-kit-sm leading-[1.45] text-[var(--inyc-primary-text-color-light)]">
      create events, assign lineups, then invite artists.
    </div>
    <div className="mt-kit-12 rounded-kit-lg border-[1px] border-[var(--inyc-input-border-color)] bg-[var(--inyc-primary)] px-kit-16 py-kit-12 text-kit-xs leading-[1.45] text-[var(--inyc-primary-text-color-light)]">
      <p>
        our avails/booking software helps local small businesses and venues
        easily book talent, instantly post on in—yc, instantly updates their
        website and also has tools and features to seamlessly share across your
        social media platforms.
      </p>
      <p className="mt-kit-10">
        it shows performers which nights a comedy club, hotel or rooftop etc.
        has open, and lets promoters or acts request a booking without a string
        of calls and emails. it keeps the club's calendar in one live, shared
        place instead of scattered across texts and spreadsheets.
      </p>
      <p className="mt-kit-10">
        for more information, please email{" "}
        <a href="mailto:info@inyc.us" className="font-['Primary-Bold'] underline">
          info@inyc.us
        </a>
      </p>
    </div>
  </div>
);

export default BookingsInfo;
